export const NOTIFY_VALUE_CHANGE_DELAY = 250;
